import { api } from "@/services";
import { FreigthSearchObject } from "@/types/Freight";

async function useAsyncCalculateFreight(
  cartId: string,
  zipcode: string
): Promise<[Response: FreigthSearchObject, CError: string]> {
  let Response: FreigthSearchObject = null;
  let CError = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const resp: { data: FreigthSearchObject } = await api.post(
        "Cart/CalcularFreteCarrinho",
        null,
        {
          params: {
            CheckoutId: cartId,
            cep: zipcode
          }
          // signal: Controller.signal,
        }
      );
      if (resp.data.responseShared.status) {
        Response = resp.data;
      } else {
        throw new Error(resp.data.responseShared.msgs[0]);
      }
    } catch (error) {
      CError = error.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, CError];
}

export { useAsyncCalculateFreight };
